module.exports = __webpack_public_path__ + "static/media/goat-finding-its-way.06240737.png";